var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"disabled":!_vm.isAvailable,"radio":""},on:{"click":function($event){return _vm.$emit('input', _vm.event)}}},[_vm._v(" "+_vm._s(_vm.event.startTime)+" - "+_vm._s(_vm.event.endTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }